interface SiteTableErrorProps {
  error: Error | null;
  onRetry: () => void;
}

export default function SiteTableError({
  error,
  onRetry,
}: SiteTableErrorProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="px-6 py-8 text-center">
        <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-red-100">
          <i className="ri-error-warning-line text-2xl text-red-600"></i>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          데이터를 불러올 수 없습니다
        </h3>
        <p className="text-gray-600 mb-4">
          {error?.message || '알 수 없는 오류가 발생했습니다.'}
        </p>
        <div className="space-y-2">
          <button
            onClick={onRetry}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            <i className="ri-refresh-line mr-2"></i>
            다시 시도
          </button>
        </div>
        <div className="mt-4 text-xs text-gray-500">
          계속 문제가 발생하면 관리자에게 문의하세요.
        </div>
      </div>
    </div>
  );
}
